import { Dog, IDog, IMilestone, IProfile } from '@jumpstart/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { collection, getFirestore } from 'firebase/firestore';
import React, { useState } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { app } from '../../../../core/firebase';
import { ISubscriber } from '../../schemas';
import MessageScheduler from './MessageScheduler';
import ProfileInfoView from './ProfileInfoView';
import ProfileLinkList from './ProfileLinkList';
import ProfileNotesView from './ProfileNotesView';

export interface IProfileView {
  subscriber: ISubscriber | null;
  dog: IDog | null;
  profile: IProfile | null;
  milestones: IMilestone[];
}

export default function ProfileView(props: IProfileView) {
  const { profile, dog, subscriber, milestones } = props;
  const [tasks] = useCollection(collection(
    getFirestore(app),
    'scout9-sms-subscribers',
    subscriber ? subscriber.uid : 'UNKNOWN',
    'tasks'
  ));

  // Track this because loading milestones is expensive on the client side
  const [milestonesExpanded, setMilestonesExpanded] = useState(false);

  const handleMilestoneChange = (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setMilestonesExpanded(isExpanded);
  };

  if (!dog || !profile || !subscriber) {
    return null;
  }

  return (
    <Grid
      sx={{
        overflow: 'hidden',
        width: '100%'
      }}
      direction="column"
      container wrap="nowrap"
    >
      <ProfileInfoView subscriber={subscriber} dog={dog} profile={profile}/>
      <Accordion square defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          aria-controls="Message Scheduler"
          id="message-scheduler"
        >
          <Typography variant="caption">Scheduled Messages</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            overflowY: 'scroll',
            maxHeight: 330
          }}
        >
          {
            subscriber && dog && profile ?
              <MessageScheduler
                subscriber={subscriber}
                dogDaysOld={parseInt(Dog.ageFrom(dog.dob, 'days').toFixed(0), 10)}
                dog={dog}
                profile={profile}
              />
              : null
          }
        </AccordionDetails>
      </Accordion>
      <Accordion square defaultExpanded={tasks ? tasks.size > 0 : false}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          aria-controls="Profile Tasks"
          id="profile-view-tasks"
        >
          <Typography variant="caption">{profile && profile.firstName ? profile.firstName + '\'s' : ''} Notes &
            Tasks</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{
          overflowY: 'scroll',
          maxHeight: 330
        }}>
          <ProfileNotesView subscriber={subscriber} dog={dog} profile={profile} tasks={tasks as any}/>
        </AccordionDetails>
      </Accordion>
      <Accordion square>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          aria-controls="Profile Links"
          id="profile-links"
        >
          <Typography variant="caption">Links</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{
          overflowY: 'scroll',
          maxHeight: 330
        }}>
          {subscriber ? <ProfileLinkList subscriber={subscriber}/> : null}
        </AccordionDetails>
      </Accordion>
      {/*<Accordion square expanded={milestonesExpanded} onChange={handleMilestoneChange}>*/}
      {/*  <AccordionSummary*/}
      {/*    expandIcon={<ExpandMoreIcon/>}*/}
      {/*    aria-controls="Profile Milestones"*/}
      {/*    id="profile-view-milestones"*/}
      {/*  >*/}
      {/*    <Typography variant="caption">{dog ? dog.name + '\'s' : ''} Milestones</Typography>*/}
      {/*  </AccordionSummary>*/}
      {/*  <AccordionDetails   sx={{
            overflowY: 'scroll',
            maxHeight: 330
          }}>*/}
      {/*    {milestonesExpanded ? <ProfileMilestonesView milestones={milestones} dog={dog}/> : null}*/}
      {/*  </AccordionDetails>*/}
      {/*</Accordion>*/}
    </Grid>
  );
}
